
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { BusinessDtoModel } from 'models/generated/Models.LeadsApi.BusinessDto';


const _gormCrm_LeadControllerHelper = new Map<string, Object>();
_gormCrm_LeadControllerHelper.set('GetLeads', BusinessDtoModel);


export const gormCrm_LeadControllerHelper = _gormCrm_LeadControllerHelper;

